import styled from '@emotion/styled';

export const Link = styled.a`
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
  text-decoration-line: underline;
  color: #007eba;
`;
